import { Classes} from "@/imports-files/components/congrats";
import {
  Button,
  ConfirmationModalStyle,
} from "@/imports-files/components/common-modal/common-modal";

function Congrats(props) {

  let heightClass = props.heightClass ? props.heightClass : '';

  return props.trigger ? (
    <div className={`${ConfirmationModalStyle.ModalOverlay}`}>
      <div className={`${ConfirmationModalStyle.Modal}`}>
        <div className={`${ConfirmationModalStyle.Modal__Container}`}>
          {props.children}
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}

export default Congrats;
